/*
 * @Author: liangliang
 * @Date: 2023-07-02 14:08:11
 * @LastEditors: yusha
 * @LastEditTime: 2024-07-23 16:20:56
 * @Description:
 */
import Index from "@/views/index/Index.vue";
import Login from "@/views/signup/Login.vue";
import Signin from "@/views/signup/Signin.vue";
import type { RouteRecord, RouteRecordRaw } from "vue-router";
import { markRaw } from "vue";
import type { Commit, Dispatch } from "vuex";
import {
  getUser,
  changeShop,
  getNotProcessedOrder,
  getShippingListNum,
  checkPalletWhite,
  changeLoginByType,
} from "@/apis/login";
import user, { setUserRouter } from "@/router/modules/user";
import { confirmLogin, valiAccess } from "@/util/useConfirm";
import useService, { toggleService } from "@/util/useService";
import useChannelName from "@/util/useChannelName";
import { resetRate } from "@/util/useYan";
import { getNewMemberActivity } from "@/util/useNewMember";
import { isD2C, useRtfix, useSite2Station } from "..";
import { getRateByMemberShipId } from "@/apis/addition";
import { stationCodeToSite } from "@/util/checkStation";
import { getCustomerWalletList } from "@/apis/fund";

import { useRoute, useRouter } from "vue-router";
import { Site, UseType } from "@/common/const";
import { getVipCombo } from "@/apis/usercenter";
import { getCustomer2AgencySign, getIsChoiceShopApi } from "@/apis/user";
import { channelList } from "@/common/promotionChannel";
import { taSetUser, thinkingdata } from "@/util/buryingPoint";
import router from "@/router";
import { request } from "@/config/request/interceptors";

// const station = useSite2Station()

const common: RouteRecordRaw[] = [
  {
    path: "redirext/:path",
    component: () => import("@/views/(mall).vue"),
  },
  {
    path: "/choice",
    component: () => import("@/views/(mall).vue"),
  },
  // 特殊会员推广页面，B2B和D2C都需要访问
  {
    path: "/special/invite",
    name: "specialInvitation",
    meta: {
      noLoginAccess: true,
    },
    component: () => import("@/views/usercenter/VipLevel/invitation.vue"),
  },
  {
    path: "activity",
    name: "activity",
    meta: {
      noLoginAccess: true,
    },
    component: () => import("@/views/activity/index.vue"),
    children: [
      // {
      //   path: 'christmas',
      //   name: 'christmas',
      //   component: () => import('@/views/activity/christmas.vue')
      // },
      {
        path: "valentinesday",
        name: "valentinesday",
        component: () => import("@/views/activity/valentinesday.vue"),
      },
      {
        path: "tiktok",
        name: "tiktok",
        component: () => import("@/views/activity/tiktok.vue"),
      },
      {
        path: "springHot",
        name: "springHot",
        component: () => import("@/views/activity/springHot.vue"),
      },
      {
        path: "easter",
        name: "easter",
        component: () => import("@/views/activity/easter.vue"),
      },
      {
        path: "summerOutfits",
        name: "summerOutfits",
        component: () => import("@/views/activity/summerOutfits.vue"),
      },
      {
        path: "beachMustHave",
        name: "beachMustHave",
        component: () => import("@/views/activity/beachMustHave.vue"),
      },
    ],
  },
  // 品牌出海 品牌页
  {
    path: "brand",
    name: "brand",
    meta: {
      noLoginAccess: true,
    },
    component: () => import("@/views/brand/Index.vue"),
    children: [
      {
        path: "detail/:brand",
        name: "BrandDetail",
        component: () => import("@/views/brand/detail/Index.vue"),
      },
      {
        path: "list",
        name: "BrandList",
        component: () => import("@/views/brand/list/Index.vue"),
      },
    ],
  },
  //   成本计算器未登录
  {
    path: "/Calculator/Unlogin",
    name: "unlogin",
    meta: {
      noLoginAccess: true,
    },
    component: () => import("@/views/microapp/Unlogin.vue"),
  },

  // 品牌出海 新增授权
  {
    path: "brandauth",
    name: "BrandAuth",
    component: () => import("@/views/brand/auth/Index.vue"),
  },
  {
    path: "/auth",
    name: "auth",
    meta: {
      noLoginAccess: true,
    },
    component: () => import("@/views/index/auth.vue"),
  },
  {
    path: "/ckb",
    name: "ckb",
    meta: {
      noLoginAccess: true,
    },
    component: () => import("@/views/ckbChoice/index.vue"),
    children: [
      {
        path: "choice/:code",
        name: "ckbChoice",
        meta: {
          noLoginAccess: true,
        },
        component: () => import("@/views/ckbChoice/list.vue"),
      },
      {
        path: "detail/:code",
        name: "ckbDetail",
        meta: {
          noLoginAccess: true,
        },
        component: () => import("@/views/ckbChoice/detail.vue"),
      },
      {
        path: "history",
        name: "ckbHistory",
        meta: {
          noLoginAccess: true,
        },
        component: () => import("@/views/ckbChoice/history.vue"),
      },
    ],
  },
  ...user,
  {
    path: "",
    name: "bussiness",
    component: () => import("@/views/Bussiness.vue"),
    redirect: ({ path }) => {
      return path + "/hub/ec";
    },
    children: [
      {
        path: "index",
        name: "index",
        component: markRaw(Index),
        meta: {
          noShopAccess: true,
        },
        children: [
          {
            path: "channel",
            name: "channel",
            component: () => import("@/views/index/Channel/Index.vue"),
          },
          {
            path: "",
            name: "pure",
            meta: {
              noLoginAccess: true,
            },
            redirect: ({ path }) => {
              return path + "/hub/ec";
            },
            component: () => import("@/views/index/Pure/Index.vue"),
            children: [
              {
                path: "pure",
                name: "pureIndex",
                meta: {
                  noLoginAccess: true,
                },
                component: () => import("@/views/index/Pure/Pure.vue"),
              },
              {
                path: "platform/:type",
                name: "platform",
                meta: {
                  noLoginAccess: true,
                },
                component: () => import("@/views/index/Platform/Index.vue"),
              },
            ],
          },
          {
            path: "market",
            name: "market",
            meta: {
              noLoginAccess: true,
            },
            component: () =>
              import("@/views/index/MarketToTransparent/index.vue"),
          },
        ],
      },
      {
        path: "market",
        name: "market_layout",
        meta: {
          noLoginAccess: true,
        },
        component: () => import("@/views/market/Index.vue"),
        children: [
          {
            path: "wsy",
            name: "market_wsy",
            meta: {
              noLoginAccess: true,
            },
            component: () => import("@/views/market/wsy/wsyMarket.vue"),
          },
          {
            path: "vvic",
            name: "market_vvic",
            meta: {
              noLoginAccess: true,
            },
            component: () => import("@/views/market/vvic/vvicMarket.vue"),
          },
          {
            path: "vvic/list",
            name: "market_vvic_list",
            meta: {
              noLoginAccess: true,
            },
            component: () => import("@/views/market/vvic/list.vue"),
          },
        ],
      },
      {
        path: "oemquest",
        name: "oemQuest",
        meta: {
          memberLevel: 1,
        },
        component: () => import("@/views/oem/Quest/Index.vue"),
      },
      {
        path: "list",
        name: "list",
        meta: {
          noShopAccess: true,
          noLoginAccess: true,
        },
        component: () => import("@/views/list/Index.vue"),
      },
      {
        path: "goods/:id",
        name: "goods",
        meta: {
          noShopAccess: true,
          noLoginAccess: true,
        },
        component: () => import("@/views/goods/Index.vue"),
      },
      {
        path: "shopcart",
        name: "shopcart",
        meta: {
          name: "shopcart",
        },
        component: () => import("@/views/shopcart/container.vue"),
      },
      {
        path: "group",
        name: "groupProduct",
        component: () => import("@/views/shopcart/Group.vue"),
      },
      {
        path: "help",
        name: "help",
        meta: {
          noLoginAccess: true,
        },
        component: () => import("@/views/help/Index.vue"),
      },
      {
        path: "helpvideo",
        name: "helpvideo",
        meta: {
          noLoginAccess: true,
        },
        component: () => import("@/views/help/helpvideo.vue"),
      },
      {
        path: "agreement",
        name: "agreement",
        meta: {
          noLoginAccess: true,
        },
        component: () => import("@/views/help/Policy.vue"),
      },
      {
        path: "policy",
        name: "policy",
        meta: {
          noLoginAccess: true,
        },
        component: () => import("@/views/help/Policy.vue"),
      },
      {
        path: "iframe/:name",
        name: "iframe",
        meta: {
          noLoginAccess: true,
        },
        component: () => import("@/views/iframe/Index.vue"),
      },
      {
        path: "kaerumedia",
        name: "kaerumedia",
        meta: {
          noLoginAccess: true,
        },
        component: () => import("@/views/kaerumedia/Index.vue"),
      },
      {
        path: "stockJpManual",
        name: "stockJpManual",
        meta: {
          noLoginAccess: true,
        },
        component: () => import("@/views/help/StockJpManual.vue"),
      },
      {
        path: "article/:type/:id",
        name: "article",
        meta: {
          noLoginAccess: true,
        },
        component: () => import("@/views/article/Index.vue"),
      },
    ],
  },
];
const renameRoutes = (
  routes: RouteRecordRaw[],
  plat: string,
  country?: string
): RouteRecordRaw[] => {
  return routes.map((v) => {
    const route = {
      ...v,
      meta: {
        ...v.meta,
      },
    };
    if (typeof route.name === "string") {
      route.name = `${route.name}${country ? "_" + country : ""}`;
    }
    if (Array.isArray(v.children)) {
      route.children = renameRoutes(v.children, "", country);
    }
    return route;
  });
};

const routes: RouteRecordRaw[] = tarnsRoute([
  {
    path: "/signin",
    name: "signin",
    component: markRaw(Signin),
    redirect: "/login",
    children: [
      {
        path: "/login",
        name: "login",
        meta: {
          noLoginAccess: true,
          haveTokenForbit: true,
        },
        component: markRaw(Login),
        children: [
          {
            path: "findpwd",
            name: "findpwd",
            component: () => import("@/views/signup/components/FindPwd.vue"),
          },
        ],
      },
      {
        path: "/login_h5",
        name: "login_h5",
        meta: {
          noLoginAccess: true,
          haveTokenForbit: true,
        },
        component: () => import("@/views/signup/Login_h5.vue"),
      },
      {
        path: "/signup",
        name: "signup",
        meta: {
          noLoginAccess: true,
          haveTokenForbit: true,
        },
        component: () => import("@/views/signup/Signup.vue"),
      },
      {
        path: "/signup_h5",
        name: "signup_h5",
        meta: {
          noLoginAccess: true,
          haveTokenForbit: true,
        },
        component: () => import("@/views/signup/Signup_h5.vue"),
      },
      {
        path: "/logOutApp",
        name: "logOutApp",
        meta: {
          noLoginAccess: true,
          // haveTokenForbit: true
        },
        component: () => import("@/views/signup/logOutApp.vue"),
      },
    ],
  },
  // {
  //   path: '/d2c',
  //   name: 'd2c',
  //   redirect: () => {
  //     return '/' + (SRoute.state.site || 'ja') + '/hub/ec'
  //   }
  // },
  // {
  //   path: '/b2b',
  //   name: 'b2b',
  //   redirect: () => {
  //     return '/' + (SRoute.state.site || 'ja') + '/hub/ec'
  //   }
  // },
  ...["/", "/ko", "/ja", "/en"].map((i: any) => {
    return {
      path: i,
      component: () => import("@/views/Home.vue"),
    };
  }),
  ...["ja", "ko", "en"].map((i: any) => {
    return {
      path: "/" + i,
      name: i,
      component: () => import("@/views/Home.vue"),
      children: renameRoutes(common, "", i),
    };
  }),
  {
    path: "/live",
    name: "live",
    meta: {
      noLoginAccess: true,
    },
    component: () => import("@/views/live/LiveDetail/index.vue"),
  },
  {
    path: "/:catchAll(.*)",
    redirect: "/404",
  },
  {
    path: "/404",
    name: "404",
    meta: {
      noLoginAccess: true,
    },
    component: () => import("@/views/error/404.vue"),
  },
  {
    path: "/403",
    name: "403",
    meta: {
      noLoginAccess: true,
    },
    component: () => import("@/views/error/403.vue"),
  },
  {
    // 黑名单商品提示页
    path: "/blacklist",
    name: "blacklist",
    meta: {
      noLoginAccess: true,
    },
    component: () => import("@/views/error/blacklist.vue"),
  },
  {
    path: "/sub/:id",
    name: "announce",
    component: () => {},
  },
]);

function tarnsRoute(routes: Array<RouteRecordRaw>) {
  return routes;
}

function addNext(routes: any) {
  return routes.map((v: any) => {
    const item = {
      ...v,
      path: `/next${v.path}`,
      children: v.children,
    };
    if (v.path === "/:catchAll(.*)") {
      item.redirect = `/next${v.redirect}`;
    }
    return item;
  });
}

const day = 1000 * 3600 * 24;
const browserLang = navigator.language.split("-")[0] || "ja";
const originLang = ["ja", "ko"].indexOf(browserLang) > -1 ? browserLang : "en";
export declare interface state {
  routes: RouteRecordRaw[];
  plat: string;
  token: string | null;
  curShop: number | null;
  curShopInfo: any;
  promise: Promise<void>;
  user: any;
  notProcessedOrder: any;
  userRoutes: RouteRecordRaw[];
  shippingListNum: any;
  shopId: number | string;
  site: string;
  memberRate: number;
  /** 是否一价全包白名单有户 */
  isAllCalUser: boolean;
  ip: number;
  href: string;
  bcSelect: boolean;
  isChoiceShop: boolean;
  moreWareConfig: any;
  lineActivity: any;
}

const reg = /(\/ko|\/en|\/ja)/;
/**
 * 改写路由
 * @param pathTo
 */
const changePath = (pathTo: any) => {
  const originPath = pathTo?.redirectedFrom?.fullPath;
  // 针对/ja/b2b/fund/index => /ja/fund/index
  if (
    pathTo.path === "/404" &&
    typeof originPath === "string" &&
    /\/(d2c|b2b)/.test(originPath) &&
    reg.test(originPath)
  ) {
    return originPath.replace(/\/(d2c|b2b)/, "");
  }
  if (
    pathTo.path === "/404" &&
    typeof originPath === "string" &&
    !reg.test(originPath) &&
    /\/(d2c|b2b)/.test(originPath)
  ) {
    return `/${SRoute.state.site}${originPath.replace(/\/(d2c|b2b)/, "")}`;
  }
  // 针对ko站点url为ja的情况 /ko/fund/index => /ja/fund/index
  if (reg.test(pathTo.path) && pathTo.path.indexOf(SRoute.state.site) === -1) {
    return pathTo.fullPath.replace(reg, "/" + SRoute.state.site);
  }
  // 针对 /goods/xxx => /ja/goods/xxx
  if (
    pathTo.path === "/404" &&
    typeof originPath === "string" &&
    originPath.startsWith("/goods/") &&
    !reg.test(originPath)
  ) {
    return `/${SRoute.state.site}${originPath}`;
  }
  return false;
};
/**
 * 对 /goods/ 开头的路由重定向 返回新路由
 * @param isLogin 是否登录
 * @param originPath 原来的路由
 * @returns 新路由地址
 */
const getNewPathForStartWithsGoodsPath = (
  isLogin: boolean,
  originPath: string,
  isD2C?: boolean
) => {
  if (!isLogin) return `${originPath}`;
  return originPath;
};
// const originPath = to?.redirectedFrom?.path

const SRoute = {
  namespaced: true,
  state: {
    routes,
    user: null,
    curShop: null,
    curShopInfo: {},
    plat: "d2c",
    signupQuery: {},
    uuid: "",
    promise: Promise.resolve(),
    token: null,
    bcSelect: false, // 是否选择过to2 toc
    isAllCalUser: false,
    moreWareConfig: {},
    notProcessedOrder: {
      wholeProcessOrderCount: 0,
      skuProcessOrderCount: 0,
      totalOrderCount: 0,
      abnormalOrderCount: 0,
      deliveryAbnormalOrderCount: 0,
      measureOrderCount: 0,
    },

    shippingListNum: { byOrderCount: 0, bySkuCount: 0, totalCount: 0 },
    userRoutes: [],
    shopId: "", // 会员充值新增店铺时临时用
    shopInfo: {}, // 会员充值新增店铺时临时用
    site: originLang, // 站点
    loginName: "", // 注册时登录名a8s用
    onlyOpenSpecail: false, // 仅支持开通特殊会员 针对【不能开通普通会员】的用户，前台不展示普通会员1日元活动引导，替换成日常会员引导。
    ip: null,
    href: "",
    // 是否是choice店铺
    isChoiceShop: false,
    lineActivity: null,
  },
  getters: {
    userRoutes(state: { userRoutes: RouteRecordRaw[] }): RouteRecordRaw[] {
      return state.userRoutes;
    },
    getShopId(state: { shopId: any }) {
      return state.shopId;
    },
    getShopInfo(state: { shopInfo: any }) {
      return state.shopInfo;
    },
    getCurShopInfo(state: { curShopInfo: any }) {
      return state.curShopInfo;
    },
  },
  mutations: {
    SET_USERROUTES: (
      state: { userRoutes: RouteRecordRaw[] },
      routes: RouteRecordRaw[]
    ): void => {
      state.userRoutes = routes;
    },
    SET_SHOP_ID: (state: { shopId: any }, id: any): void => {
      state.shopId = id;
    },
    SET_SHOP_INFO: (state: { shopInfo: any }, shopInfo: any): void => {
      state.shopInfo = shopInfo;
    },
    SET_LOGIN_NAME: (state: { loginName: string }, loginName: string): void => {
      state.loginName = loginName;
    },
  },
  actions: {
    // 可以返回新路由
    async validator(
      {
        commit,
        state,
        dispatch,
      }: { commit: Commit; state: state; dispatch: Dispatch },
      { to, from }: { to: any; from: RouteRecord }
    ): Promise<any> {
      await state.promise;
      // url判断
      if (to.path === "/") return;
      const path = changePath(to);
      if (path) return path;
      // 埋点参数
      const redirect = useChannelName(to, from);
      if (redirect) return redirect;
      //
      toggleService(to.name);
      // 登录
      if (state.token) {
        console.log(to, "to----");
        // 重定向后toCreateShop里的值已经是true所以加了
        dispatch("status/setToCreateShop", false, { root: true });
        // 没有店铺 && 没有noShopAccess不允许访问，返回首页
        if (!state.curShop && !to.meta.noShopAccess) {
          // 如果前往的页面需要登录并且没有店铺则弹窗选择店铺并且回到首页
          if (!to.meta.noLoginAccess) {
            await confirmLogin(() => {});
          }
          return "/" + state.site;
        }
        // 登录状态下不允许跳转的路由
        if (to.meta.haveTokenForbit) {
          return "/" + state.site;
        } else {
          return valiAccess(to, from, state.user);
        }
      } else {
        // 未登录状态跳转的路由需要登录
        if (!to.meta.noLoginAccess) {
          if (from.name) {
            return confirmLogin(() => valiAccess(to, from, state.user));
          } else {
            // todo:重定向store
            return "/";
          }
        }
      }
    },
    async changeToken(
      {
        commit,
        dispatch,
        state,
      }: { commit: Commit; dispatch: Dispatch; state: state },
      token: string | null
    ): Promise<void> {
      const isSameToken = token === null && token === state.token;
      commit("token", token);
      if (token) {
        commit(
          "promise",
          state.promise.then(() =>
            getUser(token)
              .then(async (res) => {
                if (res.success) {
                  taSetUser(res.data, null);

                  commit("user", res.data);
                  const list = res.data.customerShopList;
                  let has = list.find(
                    (v: any) => v.customerShopId === state.curShop
                  );
                  if (!has) {
                    has = list[0];
                    commit("curShop", list[0]?.customerShopId ?? "");
                    list[0]?.customerShopId &&
                      dispatch("changeShop", list[0].customerShopId);
                  } else {
                    if (state.curShop) {
                      dispatch("changeShop", state.curShop);
                      // 获取商品测量数量
                      dispatch("measure/getMeasureNum", {}, { root: true });
                      // 获取choice白名单信息
                      dispatch("setChoiceStatus");
                    }
                  }
                  const w: any = window;
                  w.gtag &&
                    w.gtag("config", "G-GJ3Z74XKNH", {
                      user_id: has.customerId,
                    });
                  const dataLayer = w.dataLayer || [];
                  dataLayer.push({
                    event: "login_event",
                    user_id: has.customerId,
                  });
                  w.userId = has.customerId;

                  if (res.data.systemSource === UseType.d2c) {
                    // 获取2c账号订单下单金额上限
                    dispatch("d2cOrderAmount/getD2cMoney", {}, { root: true });
                  }
                  localStorage.setItem("countryKey", "");
                  commit("site", stationCodeToSite(res.data.stationCode));
                  // 获取消息数量
                  dispatch("message/getMessageNum", {}, { root: true });
                  // 获取账单数量
                  dispatch("bill/getBillNum", {}, { root: true });
                  // 获取优惠券数量
                  dispatch("coupon/getCanUseNum", {}, { root: true });
                  // 是否CROSS MALL白名单用户
                  dispatch("whiteUser/getCrossMallShop", {}, { root: true });
                  // useService(res.data)
                  // const source = state.plat === 'b2b' ? 2 : 1
                  if (res.data.systemSource) {
                    commit("plat", res.data.systemSource === 1 ? "d2c" : "b2b");
                  }
                  request.settlement.allInclude.checkCustomer().then((res) => {
                    state.isAllCalUser = !!res.data?.supportAllInclude;
                  });

                  // 获取用户的折扣费率
                  // 用户的折扣费率
                  getRateByMemberShipId({
                    memberShipId: res.data.membership.membershipTemplateId,
                  }).then((res: any) => {
                    if (res.success) {
                      state.memberRate = res.data || 0;
                    }
                  });
                  // 跳转获取未处理订单
                  getNotProcessedOrder()
                    .then((data: any) => {
                      commit("notProcessedOrder", data);
                    })
                    .catch(() => {
                      commit("notProcessedOrder", {
                        wholeProcessOrderCount: 0,
                        skuProcessOrderCount: 0,
                        totalOrderCount: 0,
                        abnormalOrderCount: 0,
                        deliveryAbnormalOrderCount: 0,
                      });
                    });
                  // 当有店铺时在请求该接口
                  if (res.data?.customerShopList?.length > 0) {
                    /** 获取国际发货管理待确认数量 */
                    getShippingListNum()
                      .then((data: any) => {
                        commit("shippingListNum", data);
                      })
                      .catch(() => {
                        commit("shippingListNum", {
                          byOrderCount: 0,
                          bySkuCount: 0,
                          totalCount: 0,
                        });
                      });
                  }
                  // 根据用户判断是否仅支持开通特殊会员
                  getVipCombo().then((res) => {
                    const onlyOpenSpecail = res.data.every(
                      (i: any) => !i.isShow
                    );
                    commit("onlyOpenSpecail", onlyOpenSpecail);
                  });

                  resetRate();
                  // 登录状态改变新会员活动数据
                  getNewMemberActivity();
                } else {
                  setTimeout(() => {
                    router.push("/");
                  }, 200);
                }
              })
              .catch((e) => {
                window?.ECHAT?.closeMiniChat?.({ directClose: 1 });
                // debugger
                console.log(e);
                // commit('token', '')
                // commit('curShop', null)
                // commit('site', 'ja')
                // 登录状态改变刷新汇率
                resetRate();
                // 登录状态改变新会员活动数据
                getNewMemberActivity();
              })
          )
        );
      } else {
        window?.ECHAT?.closeMiniChat?.({ directClose: 1 });
        commit("user", null);
        setTimeout(() => {
          // 退出登陆后修改curShop会导致页面刷新
          commit("curShop", null);
          window?.ECHAT?.closeMiniChat?.({ directClose: 1 });
        }, 1000);
        commit("guide/RESET_GUIDE_STATE", {}, { root: true });
        // 不要重复调取接口
        if (isSameToken) return state.promise;
        // useService()
        // 登录状态改变刷新汇率
        resetRate();
        // 登录状态改变新会员活动数据
        getNewMemberActivity();
        commit("bussiness/deliverData", null, { root: true });
      }
      return state.promise;
    },
    updateUser({
      commit,
      dispatch,
      state,
    }: {
      commit: Commit;
      dispatch: Dispatch;
      state: state;
    }): void {
      dispatch("changeToken", state.token);
    },
    async changeShop(
      {
        commit,
        state,
        dispatch,
      }: { commit: Commit; state: state; dispatch: Dispatch },
      val: number
    ): Promise<void> {
      // 初始不执行，再次调用执行
      untilNextTime(() => {
        commit("bussiness/deliverData", null, { root: true });
      });
      const res = await changeShop(val);
      if (res.success) {
        commit("curShop", val);
        const res1 = await getCustomerWalletList({ stationCode: state.site });
        if (res1.success) {
          const shopInfo = res1.data.find((i: any) => i.customerShopId === val);
          commit("curShopInfo", shopInfo);
          dispatch("changeMoreWareConfig");
          dispatch("status/setJpPurchase", {}, { root: true });
        }
        // 是否CROSS MALL白名单用户
        dispatch("whiteUser/getCrossMallShop", {}, { root: true });
      }
    },
    // 获取多仓配置
    async changeMoreWareConfig({
      commit,
      state,
      dispatch,
    }: {
      commit: Commit;
      state: state;
      dispatch: Dispatch;
    }) {
      const res2 = await request.customer.shop.getShopPurchase({
        customerShopId: state.curShop!,
      });
      commit("moreWareConfig", res2.data);
    },
    asyncAddUserRoutes({
      commit,
      state,
    }: {
      commit: Commit;
      state: state;
    }): Promise<void> {
      return new Promise<void>((resolve) => {
        commit("SET_USERROUTES", setUserRouter(state.plat, state.site));
        resolve();
      });
    },
    refreshToken(
      {
        commit,
        dispatch,
        state,
      }: { commit: Commit; dispatch: Dispatch; state: state },
      token: string | null
    ) {
      dispatch("changeToken", token);
      setTimeout(() => {
        localStorage.setItem(
          "_reload_page_",
          Math.random().toString().slice(2)
        );
        // 订单详情，订单商品详情，编辑组合商品，异常订单列表tab
        const blackReg =
          /.*\/(OrderInfo|ProductInfo|group|AbnormalOrder\?abnormal=ConfirmType|AbnormalOrder\?abnormal=AfterSales|ShippingList_d2c|ShippingList|ReplenishmentList|\/inshipping\/AfterSale).*/;
        // 切换平台时有些页面无法查看需要特殊处理
        if (blackReg.test(location.href)) {
          location.href = "/";
        } else {
          location.reload();
        }
      }, 100);
    },
    setChoiceStatus({ commit }: { commit: Commit }) {
      getIsChoiceShopApi().then((res) => {
        commit("isChoiceShop", !!res.data?.supportAllInclude);
      });
    },
    async getLineActivity({ commit }: { commit: Commit }) {
      const res = await request.customer.line.checkAuth();
      commit("lineActivity", res.data);
    },
  },
  local: {
    token: 3 * day,
    curShop: 9999 * day,
    site: 3 * day,
    plat: 3 * day,
  },
};

export default SRoute;

const until = (time = 1) => {
  let call = 0;
  return (fn: () => void) => {
    if (call++ < time) return;
    return fn();
  };
};
const untilNextTime = until();
// untilNextTime(()=>{})
